import { Query } from '../../_base/actionBus/Query';

export class GetUsefulContacts extends Query<string> {}
